export const ROLES = {
    billingReader: "Billing.Read",
    billingWriter: "Billing.Writer",
    projectReader: "Project.Reader",
    projectWriter: "Project.Writer",
    reportReader: "Report.Reader",
    employeeWriter: "Employee.Write",
    employeeReader: "Employee.Reader",
    clientWriter: "Client.Writer",
    clientReader: "Client.Reader",
    timesheetReader: "Timesheet.Reader",
    timesheetEditor: "Timesheet.Editor",
    admin: "Admin",
    default:"us-east-1_yuHMf1KNJ_AzureAD"
  };

  export const SCOPES = {
    "clients.read" : "clients.read", 
    "clients.edit" : "clients.edit",
    "clients.delete" : "clients.delete",
    "employees.read" : "employees.read", 
    "employees.edit" : "employees.edit",
    "employees.delete" : "employees.delete",
    "projects.read" : "projects.read",
    "projects.edit" : "projects.edit",
    "projects.employees.edit" : "projects.employees.edit",
    "projects.employees.add" : "projects.employees.add",
    "projects.employees.delete" : "projects.employees.delete",
    "projects.task.edit" : "projects.task.edit",
    "projects.task.add" : "projects.task.add",
    "projects.task.delete" : "projects.task.delete",
    "projects.job.edit" : "projects.job.edit",
    "projects.job.add" : "projects.job.add",
    "projects.job.delete" : "projects.job.delete",
    "projects.delete" : "projects.delete",
    "reports.billing.read":"reports.billing.read",
    "reports.timesheet.read":"reports.timesheet.read",
    "reports.utilization.read":"reports.utilization.read",
    "budget.read" : "budget.read",
    "budget.edit" : "budget.edit",
    "timesheet.read" : "timesheet.read",
    "timesheet.edit" : "timesheet.edit",
    "reports.read" : "reports.read",
    "providers.read" : "providers.read",
    "providers.edit" : "providers.edit",
    "providers.delete" : "providers.delete",
    "users.read" : "users.read",
    "users.edit" : "users.edit",
    "users.delete" : "users.delete",
    "workflows.read" : "workflows.read",
    "workflows.edit" : "workflows.edit",
    "workflows.delete" : "workflows.delete",
    "pto.read": "pto.read",
    "pto.add": "pto.add",
    "pto.edit": "pto.edit",
    "nonworkingday.read": "nonworkingday.read",
    "nonworkingday.add": "nonworkingday.add",
    "nonworkingday.edit": "nonworkingday.edit",
    "timeoff.rrhh": "timeoff.rrhh",
    "invoice.read": "invoice.read",
    "invoice.add": "invoice.add",
    "invoice.edit": "invoice.edit",
    "invoice.delete": "invoice.delete",
    "invoices.read": "invoice.read",
    "invoices.add": "invoice.add",
    "invoices.edit": "invoice.edit",
    "invoices.delete": "invoice.delete",
    "invoices.supplier.read": "invoices.supplier.read",
    "invoices.supplier.add": "invoices.supplier.add",
    "accountspayable.read": "accountspayable.read",
    "accountspayable.edit": "accountspayable.edit",
    "accountspayable.client.read": "accountspayable.client.read",
    "locale.read": "locale.read",
    "locale.edit": "locale.edit",
    "locale.delete": "locale.delete",
    "corporateentity.add": "corporateentity.add",
    "corporateentity.edit": "corporateentity.edit",
    "corporateentity.delete": "corporateentity.delete",
    "taxrate.read": "taxrate.read",
    "taxrate.create": "taxrate.create",
    "taxrate.update": "taxrate.update",
    "taxrate.delete": "taxrate.delete",
    "account.read": "account.read",
    "account.add": "account.add",
    "account.edit": "account.edit",
    "account.delete": "account.delete",
    "ledger.read": "ledger.read",
    "ledger.add": "ledger.add",
    "ledger.update": "ledger.update",
    "ledger.delete": "ledger.delete",
    "invoice.type.read": "invoice.type.read",
    "invoice.type.delete": "invoice.type.delete",
    "invoice.type.add": "invoice.type.add",
    "invoice.type.edit": "invoice.type.edit",
    "supervisor.read": "supervisor.read",
    "Owner": "Owner",
    "notification.admin": "notification.admin",
    "notification.config.edit": "notification.config.edit",
    "notification.config.read": "notification.config.read",
  };
